/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  FameUploadRequestDto,
  FileDescriptor,
  FilesResponse,
  FindFilesByResourceIdAndResourceTypeParams,
  SearchFilesRequest,
  SearchFilesResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class FameController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags fame-controller
   * @name UploadFile1
   * @request POST:/api/v1/fame/files
   */
  uploadFile = (data: FameUploadRequestDto, params: RequestParams = {}) =>
    this.http.request<FileDescriptor, any>({
      path: `/v1/fame/files`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadFilePath = '/v1/fame/files'
  static uploadFileMethod = 'POST'
  /**
   * No description
   *
   * @tags fame-controller
   * @name GetPagedFiles
   * @request POST:/api/v1/fame/files/paged
   */
  getPagedFiles = (data: SearchFilesRequest, params: RequestParams = {}) =>
    this.http.request<SearchFilesResponse, any>({
      path: `/v1/fame/files/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getPagedFilesPath = '/v1/fame/files/paged'
  static getPagedFilesMethod = 'POST'
  /**
   * No description
   *
   * @tags fame-controller
   * @name FindFileById
   * @request GET:/api/v1/fame/files/{id}
   */
  findFileById = (id: string, params: RequestParams = {}) =>
    this.http.request<FileDescriptor, any>({
      path: `/v1/fame/files/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findFileByIdPath = '/v1/fame/files/${id}'
  static findFileByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags fame-controller
   * @name DeleteFile2
   * @request DELETE:/api/v1/fame/files/{id}
   */
  deleteFile = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/fame/files/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deleteFilePath = '/v1/fame/files/${id}'
  static deleteFileMethod = 'DELETE'
  /**
   * No description
   *
   * @tags fame-controller
   * @name DownloadFile2
   * @request GET:/api/v1/fame/files/{id}/file
   */
  downloadFile = (id: string, params: RequestParams = {}) =>
    this.http.request<File, any>({
      path: `/v1/fame/files/${id}/file`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static downloadFilePath = '/v1/fame/files/${id}/file'
  static downloadFileMethod = 'GET'
  /**
   * No description
   *
   * @tags fame-controller
   * @name GetFileStatus
   * @request GET:/api/v1/fame/files/{id}/fileStatus
   */
  getFileStatus = (id: string, params: RequestParams = {}) =>
    this.http.request<
      | 'FILE_DELETED'
      | 'FILE_READY'
      | 'FORMAT_NOT_SUPPORTED'
      | 'SCAN_FAILED'
      | 'SCAN_INFECTED'
      | 'NOT_APPLICABLE'
      | 'unknown_default_open_api',
      any
    >({
      path: `/v1/fame/files/${id}/fileStatus`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getFileStatusPath = '/v1/fame/files/${id}/fileStatus'
  static getFileStatusMethod = 'GET'
  /**
   * No description
   *
   * @tags fame-controller
   * @name FindFilesByResourceIdAndResourceType
   * @request GET:/api/v1/fame/files/files-by-resourceId-and-resourceType
   */
  findFilesByResourceIdAndResourceType = (
    query: FindFilesByResourceIdAndResourceTypeParams,
    params: RequestParams = {},
  ) =>
    this.http.request<FilesResponse, any>({
      path: `/v1/fame/files/files-by-resourceId-and-resourceType`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findFilesByResourceIdAndResourceTypePath =
    '/v1/fame/files/files-by-resourceId-and-resourceType'
  static findFilesByResourceIdAndResourceTypeMethod = 'GET'
}
